<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="企业名称" prop="enterpriseName">
                <a-input v-model="queryParam.enterpriseName" allow-clear placeholder="请输入企业名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="审核状态" prop="examineStatus">
                <a-select v-model="queryParam.examineStatus" :placeholder="'请选择'">
                  <a-select-option value="0">待审核</a-select-option>
                  <a-select-option value="1">审核通过</a-select-option>
                  <a-select-option value="2">审核未通过</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">

              <a-col :md="8" :sm="24">
                <a-form-item label="所属行业,外键{}" prop="sector">
                  <a-input v-model="queryParam.sector" placeholder="请输入所属行业,外键{}" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="省名称" prop="provinceName">
                  <a-input v-model="queryParam.provinceName" placeholder="请输入省名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="省编码" prop="provinceCode">
                  <a-input v-model="queryParam.provinceCode" placeholder="请输入省编码" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="市名称" prop="cityName">
                  <a-input v-model="queryParam.cityName" placeholder="请输入市名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="市编码" prop="cityCode">
                  <a-input v-model="queryParam.cityCode" placeholder="请输入市编码" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="区名称" prop="areaName">
                  <a-input v-model="queryParam.areaName" placeholder="请输入区名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="区编码" prop="areaCode">
                  <a-input v-model="queryParam.areaCode" placeholder="请输入区编码" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="详细地址" prop="detailedAddress">
                  <a-input v-model="queryParam.detailedAddress" placeholder="请输入详细地址" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode">
                  <a-input v-model="queryParam.unifiedSocialCreditCode" placeholder="请输入统一社会信用代码" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="法人姓名" prop="corporationName">
                  <a-input v-model="queryParam.corporationName" placeholder="请输入法人姓名" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="法人身份证号" prop="corporationIdNumber">
                  <a-input v-model="queryParam.corporationIdNumber" placeholder="请输入法人身份证号" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="主营业务" prop="mainBusiness">
                  <a-input v-model="queryParam.mainBusiness" placeholder="请输入主营业务" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="联系方式" prop="contactInformation">
                  <a-input v-model="queryParam.contactInformation" placeholder="请输入联系方式" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="审核原因" prop="examineReason">
                  <a-input v-model="queryParam.examineReason" placeholder="请输入审核原因" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                   {{ advanced ? '收起' : '展开' }}
                   <a-icon :type="advanced ? 'up' : 'down'"/>
                 </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['enterprise:certification:add']">
                  <a-icon type="plus" />新增
                </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['enterprise:certification:edit']">
                  <a-icon type="edit" />修改
                </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete"
                  v-hasPermi="['enterprise:certification:remove']">
          <a-icon type="delete"/>
          删除
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['enterprise:certification:export']">
                  <a-icon type="download" />导出
                </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"/>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="businessLicense" slot-scope="text, record">
          <div v-if="record.businessLicense" class="license-thumb-wrap">
            <img
              v-viewer
              class="license-thumb-img"
              :src="record.businessLicense"
              alt="营业执照"
              preview="营业执照"
            />
          </div>
          <span v-else class="license-thumb-empty">—</span>
        </span>
        <span slot="examineStatus" slot-scope="text, record">
          <a-tag v-if="record.examineStatus === 0" color="orange">待审核</a-tag>
          <a-tag v-else-if="record.examineStatus === 1" color="green">已通过</a-tag>
          <a-tag v-else-if="record.examineStatus === 2" color="red">已拒绝</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="region" slot-scope="text, record">
          {{ formatRegion(record) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider v-if="record.status === 0" v-hasPermi="['enterprise:certification:edit']" type="vertical"/>
          <a-button type="link" :disabled="record.examineStatus !== 0" v-hasPermi="['enterprise:certification:edit']"
                    @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>审核
          </a-button>
          <a-divider type="vertical" v-hasPermi="['enterprise:certification:remove']"/>
          <a @click="handleDelete(record)" v-hasPermi="['enterprise:certification:remove']">
            <a-icon type="delete"/>删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {delCertification, pageCertification} from '@/api/enterprise/certification'
import CreateForm from './modules/CreateForm'
import {tableMixin} from '@/store/table-mixin'

export default {
  name: 'Certification',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        businessLicense: null,
        enterpriseName: null,
        sector: null,
        provinceName: null,
        provinceCode: null,
        cityName: null,
        cityCode: null,
        areaName: null,
        areaCode: null,
        detailedAddress: null,
        unifiedSocialCreditCode: null,
        corporationName: null,
        corporationIdNumber: null,
        mainBusiness: null,
        contactInformation: null,
        examineStatus: null,
        examineReason: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /*{
          title: '企业认证id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '师傅姓名',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '营业执照',
          dataIndex: 'businessLicense',
          align: 'center',
          width: 132,
          scopedSlots: { customRender: 'businessLicense' }
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '所属行业',
          dataIndex: 'sectorName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '省市区',
          key: 'region',
          align: 'center',
          scopedSlots: { customRender: 'region' }
        },
        /*{
          title: '省编码',
          dataIndex: 'provinceCode',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '市名称',
          dataIndex: 'cityName',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '市编码',
          dataIndex: 'cityCode',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '区名称',
          dataIndex: 'areaName',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '区编码',
          dataIndex: 'areaCode',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '详细地址',
          dataIndex: 'detailedAddress',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: '统一社会信用代码',
          dataIndex: 'unifiedSocialCreditCode',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '法人姓名',
          dataIndex: 'corporationName',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '法人身份证号',
          dataIndex: 'corporationIdNumber',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '主营业务',
          dataIndex: 'mainBusiness',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '联系方式',
          dataIndex: 'contactInformation',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'examineStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'examineStatus' }
        },
        {
          title: '审核原因',
          dataIndex: 'examineReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'createTime',
          scopedSlots: {customRender: 'createTime'},
          align: 'center'
        },
        /*{
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '操作',
          dataIndex: 'operation',
          width: '160px',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    if (!(this.$route.query && this.$route.query.id)) {
      this.getList()
    }
  },
  computed: {},
  watch: {
    '$route.query.id': {
      handler (id) {
        this.openDetailFromRoute(id)
      },
      immediate: true
    }
  },
  methods: {
    /** 省 / 市 / 区展示 */
    formatRegion (record) {
      if (!record) return '—'
      const parts = [record.provinceName, record.cityName, record.areaName].filter(
        (p) => p != null && String(p).trim() !== ''
      )
      return parts.length ? parts.join(' / ') : '—'
    },
    openDetailFromRoute (id) {
      if (id == null || id === '') {
        return
      }
      const status = this.$route.query.examineStatus != null ? this.$route.query.examineStatus : this.$route.query.status
      if (status !== undefined && status !== null && status !== '') {
        const n = parseInt(status, 10)
        if (!Number.isNaN(n)) {
          this.queryParam.examineStatus = n
        }
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.handleUpdate({ id }, undefined)
        }
        this.clearRouteDetailIdQuery()
      })
    },
    clearRouteDetailIdQuery () {
      const q = { ...(this.$route.query || {}) }
      if (!q.id) {
        return
      }
      delete q.id
      this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
    },
    /** 查询企业认证列表 */
    getList() {
      this.loading = true
      pageCertification(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        businessLicense: undefined,
        enterpriseName: undefined,
        sector: undefined,
        provinceName: undefined,
        provinceCode: undefined,
        cityName: undefined,
        cityCode: undefined,
        areaName: undefined,
        areaCode: undefined,
        detailedAddress: undefined,
        unifiedSocialCreditCode: undefined,
        corporationName: undefined,
        corporationIdNumber: undefined,
        mainBusiness: undefined,
        contactInformation: undefined,
        examineStatus: undefined,
        examineReason: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({"id": id}))
          return delCertification(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('enterprise/enterprise-certification/export', {
            ...that.queryParam
          }, `企业认证_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* 执照约 85.6×54mm，横向略宽；列表内小图完整容纳不裁切 */
.license-thumb-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 72px;
  margin: 4px auto;
  padding: 2px;
  box-sizing: border-box;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  cursor: pointer;
  vertical-align: middle;
}
.license-thumb-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}
.license-thumb-empty {
  color: rgba(0, 0, 0, 0.25);
}
</style>
